import {Button, FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import {hideModal} from 'Core/ducks/modal';
import React, {useState} from 'react';
import Modal from 'Shared/components/Modal';
import './LegacySignOn.sass';

type LegacySignOn = {
  onClose: typeof hideModal;
  onLogin: () => any;
};

const LegacySignOn = (props: LegacySignOn) => {
  const [selectedAccount, setAccount] = useState<string | undefined>(undefined);

  return (
    <Modal onClose={props.onClose} title="Legacy Sign On" open>
      <div className="legacy-sign-on-form">
        <div>Which Account Would You Like To Use?</div>
        <FormControl className="legacy-sign-on-form__account-select">
          <InputLabel shrink={Boolean(selectedAccount)} htmlFor="account-select">
            Account
          </InputLabel>
          <Select
            value={selectedAccount}
            inputProps={{
              id: 'account-select',
            }}
            onChange={event => {
              setAccount(event.target.value as string);
            }}
          >
            <MenuItem value={10}>Gallagher</MenuItem>
            <MenuItem value={20}>Patton Group, LLC</MenuItem>
          </Select>
        </FormControl>
        <Button
          className="legacy-sign-on-form__login-button"
          disabled={!Boolean(selectedAccount)}
          color="primary"
          variant="contained"
          fullWidth
          onClick={props.onLogin}
        >
          Login
        </Button>
      </div>
    </Modal>
  );
};

export default LegacySignOn;
